import { NOTIFICATION } from '../actions/actionTypes';
import Notification from '../../models/Notification';

const initState: Notification = {
  type: '',
  message: ''
};

export default function notificationReducer(state: Notification = initState, action: any) {

  switch (action.type) {

    case NOTIFICATION:
      return {
        ...state,
        type: action.data.type,
        message: action.data.message
      };
    default: return state;
  }
};